import {
  ListViewSpecificValues,
  PreferenceGroup,
  ListViewPreferenceKey,
} from "@services/userPreferences/types";
import { SpecificPreferencesContextType } from ".";

export const defaultSpecificValues: ListViewSpecificValues = {
  columnOrder: [],
  columnWidths: {},
};

export const preferencesDefaultContextValue: SpecificPreferencesContextType = {
  loaded: false,
  errored: false,
  assetKey: ListViewPreferenceKey.ACCOUNT,
  ...defaultSpecificValues,
};
